/*
*/
import { set, merge, toggle } from 'dot-prop-immutable';
import { Action } from 'redux';
import { IAppStateType } from '../typings/shared';

export enum GeneralActionTypes {
  UPDATE = 'UPDATE',
  MERGE = 'MERGE',
  TOGGLE = 'TOGGLE'
}

export interface BaseAction<PAYLOAD_TYPE extends any, TYPE extends any> extends Action<TYPE> {
  payload: PAYLOAD_TYPE
}
export interface GeneralActionType<VALUE_TYPE = any, TYPE = any> extends BaseAction<{ path: string, value: VALUE_TYPE }, TYPE> { }

export interface GeneralUpdateAction<VALUE_TYPE = any> extends GeneralActionType<VALUE_TYPE, GeneralActionTypes.UPDATE> { }
export interface GeneralMergeAction<VALUE_TYPE = any> extends GeneralActionType<VALUE_TYPE, GeneralActionTypes.MERGE> { }
export interface GeneralToggleAction extends BaseAction<{ path: string }, GeneralActionTypes.TOGGLE> { }


export type GeneralActions = GeneralUpdateAction | GeneralMergeAction | GeneralToggleAction;

const appInitState: IAppStateType = {
  name: "Bob's APP",
  published: false,
  helloMsg: 'World',
  byeMsg: '',
  helloImg: null
};

export default {
  actionTypes: GeneralActionTypes,
  actions: {
    getGeneralUpdateAction: (path: string, value: any): GeneralUpdateAction => {
      return {
        type: GeneralActionTypes.UPDATE,
        payload: {
          path, value
        }
      }
    },

    getGeneralMergeAction: (path: string, value: any): GeneralMergeAction => {
      return {
        type: GeneralActionTypes.MERGE,
        payload: {
          path, value
        }
      }
    },

    getGeneralToggleAction: (path: string): GeneralToggleAction => {
      return {
        type: GeneralActionTypes.TOGGLE,
        payload: {
          path
        }
      }
    }
  },
  reducer: (state = appInitState, action: GeneralActions) => {
    if (!action.payload) { return state }


    let { path } = action.payload;
    let value: any;
    if ('value' in action.payload) {
      value = action.payload.value;
    }
    switch (action.type) {
      case GeneralActionTypes.UPDATE:
        if (typeof value == 'function') {
          let orginalValue = value;
          value = (v: any) => {
            return orginalValue(v, state);
          }
        }
        return set(state, path, value);
      case GeneralActionTypes.MERGE:
        return merge(state, path, value);
      case GeneralActionTypes.TOGGLE:
        return toggle(state, path);
      default:
        return state
    }
  }
}
